import React from 'react';
import isFunction from 'lodash/isFunction';

import { AlignItems, Direction, JustifyContent } from './types';

export const DIRECTION_CLASSNAME: { [key in Direction]: string } = {
  col: 'flex-col',
  'col-reverse': 'flex-col-reverse',
  row: 'flex-row',
  'row-reverse': 'flex-row-reverse',
};

export const ALIGN_ITEMS_CLASSNAME: { [key in AlignItems]: string } = {
  baseline: 'items-baseline',
  center: 'items-center',
  end: 'items-end',
  start: 'items-start',
  stretch: 'items-stretch',
};

export const JUSTIFY_CONTENT_CLASSNAME: { [key in JustifyContent]: string } = {
  around: 'justify-around',
  between: 'justify-between',
  center: 'justify-center',
  end: 'justify-end',
  evenly: 'justify-evenly',
  start: 'justify-start',
  normal: 'justify-normal',
};

export const joinChildren = (
  children: React.ReactNode,
  divider: ((index?: number) => JSX.Element) | React.ReactElement,
) => {
  const childrenArray = React.Children.toArray(children);

  return childrenArray.reduce((acc: React.ReactNode[], child, index) => {
    acc.push(child);

    if (index < childrenArray.length - 1) {
      acc.push(
        React.cloneElement(isFunction(divider) ? divider(index) : divider, {
          key: `divider-${index}`,
        }),
      );
    }

    return acc;
  }, []);
};
